// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__S+y0Y","img404":"Page404_img404__uU8Ll","text":"Page404_text__hHW5g"};